export default "__VITE_ASSET__1aX447ci__"